{
    "CRMConfiguration_Table_Headers_Description": "Descrição",
    "CRMConfiguration_Table_Headers_Type": "Tipo",
    "CRMConfiguration_Table_Headers_TelSys": "Servidor de Telefonia",
    "CRMConfiguration_Table_Headers_Partition": "Partição",
    "CRMConfiguration_Table_Headers_Device": "Dispositivo",
    "NAME": "CRMConfigurationLanguage"
}